import React from "react";
import { useParams } from "react-router-dom";
import HeaderController from "../../components/Headers/HeaderController";
import Footer from "../../components/Footer/Footer";
import "./Questionnaire.css"
import "./SchengenSuspendedQuestionnaire.css";

const SchengenSuspendedQuestionnaire: React.FC = () => {

  let { language } = useParams();


  return (


        <>
       



          <HeaderController
          showSteps={false}
          showBackButton={false}
            language={language}
            stage="Questionnaire"
          />

          {/* if state true -> Show forgot password overlay and send component closeModal property */}

          <div className="questionnaire-body-container schengen-suspended-container">
            <div className="schengen-suspended-card">
              <div className="schengen-suspended-icon">
                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="40" cy="40" r="38" stroke="#269C6E" strokeWidth="4" opacity="0.2"/>
                  <path d="M30 25C30 19.4772 34.4772 15 40 15C45.5228 15 50 19.4772 50 25V32H30V25Z" fill="#269C6E" opacity="0.3"/>
                  <rect x="22" y="30" width="36" height="30" rx="4" fill="#269C6E"/>
                  <circle cx="40" cy="45" r="4" fill="white"/>
                  <rect x="38" y="45" width="4" height="8" fill="white"/>
                </svg>
              </div>
              
              <h1 className="schengen-suspended-title">
                Service vorübergehend ausgesetzt
              </h1>
              
              <div className="schengen-suspended-divider"></div>
              
              <p className="schengen-suspended-description">
              Aufgrund der hohen Nachfrage hat die Bearbeitung von Schengen-Bescheinigungen ihre derzeitige Kapazitätsgrenze erreicht.
              </p>
              
              <div className="schengen-suspended-info-box">
                <div className="schengen-suspended-info-icon">ℹ️</div>
                <p className="schengen-suspended-info-text">
                Wir werden Sie benachrichtigen, sobald Anträge wieder angenommen werden können.
                </p>
              </div>
            </div>
          </div>
          <Footer page="Questionnaire" language={language} showFooterNext={false} />
        </>
  );
};


export default SchengenSuspendedQuestionnaire;